export default [
  {
    path: '/',
    name: 'home',
    alias: ['/home'],
    component: () => import('./views/Index'),
    meta: {
      auth: true
    }
  }
]
